import { render, staticRenderFns } from "./LPD.vue?vue&type=template&id=c8873cfc&scoped=true"
import script from "./LPD.vue?vue&type=script&lang=js"
export * from "./LPD.vue?vue&type=script&lang=js"
import style0 from "./LPD.vue?vue&type=style&index=0&id=c8873cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8873cfc",
  null
  
)

export default component.exports